import React from 'react';
import { Toolbar, withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const propTypes = { children: PropTypes.node.isRequired };
const defaultProps = {};

const styles = theme => ( {
    root: {
        display: 'flex',
        background: theme.palette.common.white,
        marginBottom: theme.spacing.unit * 3,
        border: '1px solid #ddd',
    },
} );

function Tool({ classes, children, ...props }){
    return (
        <Toolbar className={classes.root} {...props}>
            {children}
        </Toolbar>
    );
}

Tool.propTypes = propTypes;
Tool.defaultProps = defaultProps;

export default withStyles(styles, { name: 'Tool' })(Tool);
